import Header from "./components/Header";
import Hero from "./components/Hero";
import ProjectSection from "./components/ProjectSection";
import ExperienceSection from "./components/ExperienceSection";
import ContactSection from "./components/ContactSection";
import { experience, hero, projects, skills } from "./data/portfolio";

const App = () => {
  return (
    <div className="page">
      <Header />
      <main>
        <Hero hero={hero} skills={skills} />
        <ProjectSection projects={projects} />
        <ExperienceSection experience={experience} />
        <ContactSection email={hero.email} />
      </main>
    </div>
  );
};

export default App;
